const stage = {
  advertise: "advertise",
  welcome: "welcome",
  newCompany: "newCompany",
  payment: "payment",
};

export default stage;
